// extracted by mini-css-extract-plugin
module.exports = {"radio":"radio_radio__3T1hU","inner":"radio_inner__3Sg9K","point":"radio_point__VL7rS","text":"radio_text__1QOqJ"};